import { translate } from 'loankeeper-common/helpers'

export const translateBase = (key) => translate(`LKMESSAGE-${key}`)
export const translateWeb = (key) => translate(`frm_web_messages-${key}`)
export default (key) => translate(`frm_client_ind-${key}`)
